<template>
	<li
		class="sidebar-cart__list-item"
		:class="{
			'sidebar-cart__list-item--editable': editable,
			'sidebar-cart__list-item--restricted': restricted,
		}"
	>
		<div class="sidebar-cart__list-item-info">
			<div class="sidebar-cart__list-item-info-wrapper">
				<span
					class="sidebar-cart__list-item-name"
					v-html="item.detailedName || item.name"
				/>
				<span
					class="sidebar-cart__list-item-meta"
					v-if="item.variant && !item.detailedName"
					v-html="item.variant"
				/>
			</div>
			<button
				v-if="hasFeature('FEATURE_CART_ITEM_NOTES') && !item.disableNote"
				class="sidebar-cart__list-item-notes"
				:class="{
					'sidebar-cart__list-item-notes--active': item.notes
				}"
				:title="item.notes ? $t('cart.notes.buttonTitleActive') : $t('cart.notes.buttonTitleEmpty')"
				@click="$emit('notes')"
				:disabled="locked || !editable || restricted"
			>
				<SVGNote/>
			</button>
		</div>

		<QuantityCounter
			:quantity="item.quantity"
			:locked="locked || !editable || restricted"
			base-class="sidebar-cart__list-item-quantity"
			@sub="$emit('sub')"
			@add="$emit('add')"
		/>

		<div
			class="sidebar-cart__list-item-price"
			v-html="$options.filters.fwgpricecent(item.originalTotal, 'short')"
		/>

		<div
			class="sidebar-cart__list-item-details"
			v-if="item.description"
		>
			<div
				class="sidebar-cart__list-item-description"
				v-html="item.description"
			/>
		</div>
	</li>
</template>

<script>
import QuantityCounter from '@/components/QuantityCounter';

export default {
	components: {
		QuantityCounter,
	},
	props: {
		item: Object,
		locked: Boolean,
		editable: Boolean,
		restricted: Boolean,
		outside: Boolean,
	},
	mounted() {
		const parent = this.$el.parentNode;
		parent.scrollTop = parent.scrollHeight;
	}
}
</script>

<style>

</style>
